"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountBlockDropPrompt = exports.BlockDropPromptInner = void 0;
var react_1 = __importDefault(require("react"));
var DropzonesStore_1 = require("Project/BlockNew/SavedBlockDropzone/DropzonesStore");
var mobx_react_1 = require("mobx-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var classnames_1 = __importDefault(require("classnames"));
var react_transition_group_1 = require("react-transition-group");
var BlockDropPromptInner = (0, mobx_react_1.observer)(function (_a) {
    var position = _a.position;
    return (react_1.default.createElement("div", { className: "block-drop-prompt" },
        react_1.default.createElement("div", { className: "block-drop-prompt__arrow" }, position === "above" ? react_1.default.createElement(icons_1.ArrowUp, null) : react_1.default.createElement(icons_1.ArrowDown, null)),
        react_1.default.createElement("div", null,
            "Release to drop block ",
            position)));
});
exports.BlockDropPromptInner = BlockDropPromptInner;
var BlockDropPrompt = (0, mobx_react_1.observer)(function (_a) {
    var dropzonesStore = _a.dropzonesStore;
    var _b = dropzonesStore.currentDropzone, status = _b.status, viewportStatus = _b.viewportStatus;
    var hasActiveDropzone = status === DropzonesStore_1.CurrentDropzoneState.Active;
    var showAbove = hasActiveDropzone && viewportStatus === DropzonesStore_1.DropzoneViewportState.AboveViewport;
    var showBelow = hasActiveDropzone && viewportStatus === DropzonesStore_1.DropzoneViewportState.BelowViewport;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, in: showAbove, timeout: 400, classNames: "block-drop-prompt__outer-" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("block-drop-prompt__outer", "block-drop-prompt__outer--above") },
                react_1.default.createElement(BlockDropPromptInner, { position: "above" }))),
        react_1.default.createElement(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, in: showBelow, timeout: 400, classNames: "block-drop-prompt__outer-" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("block-drop-prompt__outer", "block-drop-prompt__outer--below") },
                react_1.default.createElement(BlockDropPromptInner, { position: "below" })))));
});
var mountBlockDropPrompt = function (mountReactComponent, dropzonesStore) {
    return mountReactComponent(react_1.default.createElement(BlockDropPrompt, { dropzonesStore: dropzonesStore }));
};
exports.mountBlockDropPrompt = mountBlockDropPrompt;
